import constantes from '../constants';
import moment from 'moment';
import momentTimezone from 'moment-timezone'

export const paises = [
  "AFRICA DO SUL",
  "AFEGANISTAO",
  "ALBANIA",
  "ALEMANHA",
  "ANDORRA",
  "ANGOLA",
  "ANGUILLA",
  "ANTARTIDA",
  "ANTIGUA E BARBUDA",
  "ANTILHAS HOLANDESAS",
  "ARABIA SAUDITA",
  "ARGELIA",
  "ARGENTINA",
  "ARMENIA",
  "ARUBA",
  "AUSTRALIA",
  "AUSTRIA",
  "AZERBAIJAO",
  "BAHAMAS",
  "Bahrein",
  "BANGLADESH",
  "BARBADOS",
  "BELARUS",
  "BELGICA",
  "BELIZE",
  "BENIN",
  "BERMUDAS",
  "BOLIVIA",
  "BOSNIA-HERZEGOVINA",
  "BOTSUANA",
  "BRASIL",
  "BRUNEI",
  "BULGARIA",
  "BURKINA FASSO",
  "BURUNDI",
  "BUTAO",
  "CABO VERDE",
  "CAMAROES",
  "CAMBOJA",
  "CANADA",
  "CAZAQUISTAO",
  "CHADE",
  "CHILE",
  "CHINA",
  "CHIPRE",
  "CINGAPURA",
  "COLOMBIA",
  "CONGO",
  "COREIA DO NORTE",
  "COREIA DO SUL",
  "COSTA DO MARFIM",
  "COSTA RICA",
  "Croácia (Hrvatska)",
  "CUBA",
  "DINAMARCA",
  "DJIBUTI",
  "DOMINICA",
  "EGITO",
  "EL SALVADOR",
  "EMIRADOS ARABES UNIDOS",
  "EQUADOR",
  "ERITREIA",
  "ESLOVAQUIA",
  "ESLOVENIA",
  "ESPANHA",
  "ESTADOS UNIDOS",
  "ESTONIA",
  "ETIOPIA",
  "FIJI",
  "FILIPINAS",
  "FINLANDIA",
  "FRANCA",
  "GABAO",
  "GAMBIA",
  "GANA",
  "GEORGIA",
  "GIBRALTAR",
  "Grã-Bretanha (Reino Unido, UK)",
  "Granada",
  "Grécia",
  "Groelândia",
  "Guadalupe",
  "Guam (Território dos Estados Unidos)",
  "Guatemala",
  "Guernsey",
  "Guiana",
  "Guiana Francesa",
  "Guiné",
  "Guiné Equatorial",
  "Guiné-Bissau",
  "Haiti",
  "Holanda",
  "Honduras",
  "Hong Kong",
  "Hungria",
  "Iêmen",
  "Ilha Bouvet (Território da Noruega)",
  "Ilha do Homem",
  "Ilha Natal",
  "Ilha Pitcairn",
  "Ilha Reunião",
  "Ilhas Aland",
  "Ilhas Cayman",
  "Ilhas Cocos",
  "Ilhas Comores",
  "Ilhas Cook",
  "Ilhas Faroes",
  "Ilhas Falkland (Malvinas)",
  "Ilhas Geórgia do Sul e Sandwich do Sul",
  "Ilhas Heard e McDonald (Território da Austrália)",
  "Ilhas Marianas do Norte",
  "Ilhas Marshall",
  "Ilhas Menores dos Estados Unidos",
  "Ilhas Norfolk",
  "Ilhas Seychelles",
  "Ilhas Solomão",
  "Ilhas Svalbard e Jan Mayen",
  "Ilhas Tokelau",
  "Ilhas Turks e Caicos",
  "Ilhas Virgens (Estados Unidos)",
  "Ilhas Virgens (Inglaterra)",
  "Ilhas Wallis e Futuna",
  "índia",
  "Indonésia",
  "Irã",
  "Iraque",
  "Irlanda",
  "Islândia",
  "Israel",
  "Itália",
  "Jamaica",
  "Japão",
  "Jersey",
  "Jordânia",
  "Kênia",
  "Kiribati",
  "Kuait",
  "Laos",
  "Látvia",
  "Lesoto",
  "Líbano",
  "Libéria",
  "Líbia",
  "Liechtenstein",
  "Lituânia",
  "Luxemburgo",
  "Macau",
  "Macedônia (República Yugoslava)",
  "Madagascar",
  "Malásia",
  "Malaui",
  "Maldivas",
  "Mali",
  "Malta",
  "Marrocos",
  "Martinica",
  "Maurício",
  "Mauritânia",
  "Mayotte",
  "México",
  "Micronésia",
  "Moçambique",
  "Moldova",
  "Mônaco",
  "Mongólia",
  "Montenegro",
  "Montserrat",
  "Myanma",
  "Namíbia",
  "Nauru",
  "Nepal",
  "Nicarágua",
  "Níger",
  "Nigéria",
  "Niue",
  "Noruega",
  "Nova Caledônia",
  "Nova Zelândia",
  "Omã",
  "Palau",
  "Panamá",
  "Papua-Nova Guiné",
  "Paquistão",
  "Paraguai",
  "Peru",
  "Polinésia Francesa",
  "Polônia",
  "Porto Rico",
  "Portugal",
  "Qatar",
  "Quirguistão",
  "República Centro-Africana",
  "República Democrática do Congo",
  "República Dominicana",
  "República Tcheca",
  "Romênia",
  "Ruanda",
  "Rússia (antiga URSS) - Federação Russa",
  "Saara Ocidental",
  "Saint Vincente e Granadinas",
  "Samoa Americana",
  "Samoa Ocidental",
  "San Marino",
  "Santa Helena",
  "Santa Lúcia",
  "São Bartolomeu",
  "São Cristóvão e Névis",
  "São Martim",
  "São Tomé e Príncipe",
  "Senegal",
  "Serra Leoa",
  "Sérvia",
  "Síria",
  "Somália",
  "Sri Lanka",
  "St. Pierre and Miquelon",
  "Suazilândia",
  "Sudão",
  "Suécia",
  "Suíça",
  "Suriname",
  "Tadjiquistão",
  "Tailândia",
  "Taiwan",
  "Tanzânia",
  "Território Britânico do Oceano índico",
  "Territórios do Sul da França",
  "Territórios Palestinos Ocupados",
  "Timor Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunísia",
  "Turcomenistão",
  "Turquia",
  "Tuvalu",
  "Ucrânia",
  "Uganda",
  "Uruguai",
  "Uzbequistão",
  "Vanuatu",
  "Vaticano",
  "Venezuela",
  "Vietnã",
  "Zâmbia",
  "Zimbábue"
]

export function cnvTipoLogradouro(aValor) {
  var codigo = 'RUA';
  if ((typeof aValor !== 'undefined') && (aValor.trim() != ''))
    switch (aValor.toUpperCase().trim()) {
      case 'ACESSO': codigo = 'ACS'; break;
      case 'ALAMEDA': codigo = 'ALA'; break;
      case 'AVENIDA': codigo = 'AVE'; break;
      case 'BECO': codigo = 'BEC'; break;
      case 'CAMINHO': codigo = 'CAM'; break;
      case 'ELEVADO': codigo = 'ELV'; break;
      case 'ESPACO LIVRE PUBLICO': codigo = 'ELP'; break;
      case 'ESTRADA': codigo = 'EST'; break;
      case 'LARGO': codigo = 'LRG'; break;
      case 'MARGINAL': codigo = 'MAR'; break;
      case 'PASSAGEM': codigo = 'PAS'; break;
      case 'PISTA DE COOPER': codigo = 'PDC'; break;
      case 'PRACA': codigo = 'PCA'; break;
      case 'QUADRA': codigo = 'QDR'; break;
      case 'QUARTEIRAO FECHADO': codigo = 'QTF'; break;
      case 'REDE DE MANILHAS': codigo = 'RMA'; break;
      case 'RETORNO': codigo = 'RTN'; break;
      case 'RODOVIA': codigo = 'ROD'; break;
      case 'RODOVIA - BR': codigo = 'BR'; break;
      case 'RUA': codigo = 'RUA'; break;
      case 'RUA DE PEDESTRE': codigo = 'RDP'; break;
      case 'TRAVESSA': codigo = 'TRV'; break;
      case 'TREVO': codigo = 'TRE'; break;
      case 'TRINCHEIRA': codigo = 'TRI'; break;
      case 'TUNEL': codigo = 'TUN'; break;
      case 'VIA': codigo = 'VIA'; break;
      case 'VIA DE PEDESTRE': codigo = 'VDP'; break;
      case 'VIADUTO': codigo = 'VDT'; break;
    }
  var retorno = 'RUA';
  var v = ['ACS', 'ALA', 'AVE', 'BEC', 'EST', 'MAR', 'ROD', 'BR', 'RUA', 'TRV', 'VIA', 'PCA'];
  for (var i = 0; i < v.length; i++)
    if (codigo == v[i]) {
      retorno = codigo;
      break;
    }
  return retorno;
}

export const meses = [
  { text: "Janeiro", value: '01', disabled: false },
  { text: "Fevereiro", value: '02', disabled: false },
  { text: "Março", value: '03', disabled: false },
  { text: "Abril", value: '04', disabled: false },
  { text: "Maio", value: '05', disabled: false },
  { text: "Junho", value: '06', disabled: false },
  { text: "Julho", value: '07', disabled: false },
  { text: "Agosto", value: '08', disabled: false },
  { text: "Setembro", value: '09', disabled: false },
  { text: "Outubro", value: '10', disabled: false },
  { text: "Novembro", value: '11', disabled: false },
  { text: "Dezembro", value: '12', disabled: false },
]

export async function getEnv() {
  try {
    let data = await fetch(`${constantes.BASE_URL}/env.json`, {
      mode: "no-cors",
    });
    let result = data.json();
    return result;
  } catch (err) {
    console.log(err);
  }
}

export function formatDate(date) {
  //var dataInput = '2020-02-06';

  let data = new Date(date);
  let dataFormatada = data.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
  return dataFormatada;
}


const formatCPF = (value) => {
  if (value) {
    value = value.replace(/(\d{3})(\d)/, "$1.$2")       //Coloca um ponto entre o terceiro e o quarto dígitos
    value = value.replace(/(\d{3})(\d)/, "$1.$2")       //Coloca um ponto entre o terceiro e o quarto dígitos de novo (para o segundo bloco de números)
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2") //Coloca um hífen entre o terceiro e o quarto dígitos
  }
  return value;
}


const formatDateHourToDate = (value) => {
  if (value) {
    return moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY');
  }
  return null;
}

const formatDateHourToDateTimeBr = (value) => {
  if (value) {
    return moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
  }
  return null;
}

const formatTimeZoneToDateTimeBr = (value) => {
  if (value) {
    return momentTimezone.tz(value, 'America/Sao_Paulo').format('DD/MM/YYYY HH:mm:ss');
  }
  return null;
}

const getMonthName = (month) => {
  var monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
  return monthNames[month - 1];
}


const getFirstDayMonth = (ano, mes) => {
  return moment(new Date(ano, mes - 1, 1)).format("YYYY-MM-DD");
}

const getLastDayMonth = (ano, mes) => {
  return moment(new Date(ano, mes, 0)).format("YYYY-MM-DD");
}


const getExtensaoArquivo = (filename) => {
  return '.' + filename.split('.').pop();
}

const validaExtensaoArquivo = (filename, extPermitidas) => {
  const extFile = getExtensaoArquivo(filename);
  return extPermitidas.find(function (ext) { return extFile.toLowerCase() == ext.toLowerCase(); });
}

const showToast = (el, titulo, mensagem, variant) => {
  el.$bvToast.toast(mensagem, {
    title: titulo,
    variant: variant,
    solid: true
  });
}


const modalConfirmacao = (el, title, message, size,okVariant, okTitle) => {
  return el.$bvModal.msgBoxConfirm(message,
    {
      title,
      size,
      buttonSize: 'sm',
      okVariant,
      okTitle,
      cancelVariant: 'outline-secondary',
      cancelTitle: 'CANCELAR',
      hideHeaderClose: false,
      centered: true
    });
}


const confirmaExclusao = (el, message = 'Confirma a exclusão do registro.', title = 'Exclusão de registro', okVariant = 'danger', okTitle = 'EXCLUIR') => {
  return el.$bvModal.msgBoxConfirm(message,
    {
      title,
      size: 'sm',
      buttonSize: 'sm',
      okVariant,
      okTitle,
      cancelVariant: 'outline-secondary',
      cancelTitle: 'CANCELAR',
      hideHeaderClose: false,
      centered: true
    });
}

const confirmaVoltar = (el, message = 'Existem alterações que não foram salvas. Deseja mesmo sair ?', title = 'Dados não salvos', okVariant = 'danger', okTitle = 'SIM', cancelTitle = 'NÃO', hideHeaderClose = true) => {
  return el.$bvModal.msgBoxConfirm(message,
    {
      title,
      size: 'sm',
      buttonSize: 'sm',
      okVariant,
      okTitle,
      cancelVariant: 'outline-secondary',
      cancelTitle,
      hideHeaderClose,
      centered: true
    });
}

const downloadFile = (blob, fileName) => {
  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
}

function getOptsKeycloak(env) {
  return {
    "realm": "PBH",
    "auth-server-url": env.ACESSO_URL,
    "ssl-required": "external",
    "resource": "AUXILIO-BH",
    "public-client": true,
    "verify-token-audience": true,
    "use-resource-role-mappings": true,
    "confidential-port": 0,
    "clientId": env.ACESSO_CLIENT_ID
  }
}

const formatReal = (value) => {
  if (value) {
    let val = (value / 1).toFixed(2).replace('.', ',')
    return "R$ " + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  }
}


export default {
  paises, cnvTipoLogradouro, getEnv, formatDate, formatCPF, formatDateHourToDate, getMonthName,
  getFirstDayMonth, getLastDayMonth, validaExtensaoArquivo, modalConfirmacao, confirmaExclusao,
  confirmaVoltar, showToast, downloadFile, getOptsKeycloak, formatDateHourToDateTimeBr, formatTimeZoneToDateTimeBr, meses, formatReal
}
